import colors from '../../colors';

const form = {
  backgroundColor: colors.primary.darkGrey2,
  borderColor: colors.primary.grey1,
  inputTextColor: colors.primary.ltGrey2,
  placeholderColor: colors.primary.ltGrey2,
  labelColor: colors.primary.ltGrey2,
  state: {
    error: {
      borderColor: colors.accent.red,
    },
    active: {
      borderColor: colors.primary.primary,
    },
    selected: {
      backgroundColor: colors.accent.dkBlue4,
    },
    disabled: {
      backgroundColor: colors.primary.ltGrey1,
      inputTextColor: colors.primary.grey2,
    },
  },
  option: {
    state: {
      selected: {
        backgroundColor: colors.accent.dkBlue4,
      },
    },
  },
};

export default form;
